import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { QuarterSelectorState, QuarterSelectorType } from '@miq/shared-models';
@Injectable()
export class QuarterSelectorStateService implements OnDestroy {
  private currentState: QuarterSelectorState;
  private onFinishSelectionSubject: Subject<void>;
  private onStateChangedSubject: Subject<void>;
  public isAValidState = false;
  public label = '';
  constructor() {
    this.onFinishSelectionSubject = new Subject();
    this.onStateChangedSubject = new Subject();
  }
  ngOnDestroy() {
    if (this.onFinishSelectionSubject) {
      this.onFinishSelectionSubject.complete();
      this.onFinishSelectionSubject = undefined;
    }
    if (this.onStateChangedSubject) {
      this.onStateChangedSubject.complete();
      this.onStateChangedSubject = undefined;
    }
  }
  public onFinishSelection(): Observable<void> {
    return this.onFinishSelectionSubject.asObservable();
  }
  public onStateChanged(): Observable<void> {
    return this.onStateChangedSubject.asObservable();
  }
  public setStateAndNotify(state: QuarterSelectorState) {
    this.setState(state);
    this.notifyStateChange();
  }
  public setStateAndFinishSelection(state: QuarterSelectorState) {
    this.setState(state);
    this.finishSelection();
  }
  private notifyStateChange() {
    this.onStateChangedSubject.next(null);
  }
  private setState(state: QuarterSelectorState) {
    this.currentState = state;
    this.isAValidState = this.validState(state);
  }
  private finishSelection() {
    this.onFinishSelectionSubject.next(null);
  }
  public getState(): QuarterSelectorState {
    return this.currentState;
  }
  /**
   * This function is called by other parts of the code to validate the state.
   * It should not affect any internal variable of the service
   */
  public validState(state: QuarterSelectorState): boolean {
    let isValid = false;
    if (state != null) {
      const yearValid = state.requiredYear ? state.periodYear != null && state.periodYear > 0 : true;
      const maxValueAllowed = state.selectorType === QuarterSelectorType.Quarter ? 4 : 12;
      const valueValid = state.periodValue != null && state.periodValue > 0 && state.periodValue <= maxValueAllowed;
      const valueBetweenLimits = this.isValueBetweenLimits(state);
      isValid =
        yearValid &&
        (state.selectorType === QuarterSelectorType.Yearly || valueValid) &&
        state.selectorType != null &&
        valueBetweenLimits;
    }
    return isValid;
  }
  private isValueBetweenLimits(state: QuarterSelectorState): boolean {
    if (state.periodYear < state.minValue.periodYear || state.periodYear > state.maxValue.periodYear) {
      return false;
    }
    if (state.periodYear === state.minValue.periodYear && state.periodValue < state.minValue.periodValue) {
      return false;
    }
    if (state.periodYear === state.maxValue.periodYear && state.periodValue > state.maxValue.periodValue) {
      return false;
    }
    return true;
  }
}
